import Swiper from 'swiper/bundle';
import ClassWatcher from './classes/ClassWatcher'

let swiper = null;

let arrowNext = document.querySelector('.speakers-slider__arrow--next'),
    arrowPrev = document.querySelector('.speakers-slider__arrow--prev'),
    nextSlideMessage = arrowNext ? arrowNext.dataset.title : '',
    prevSlideMessage = arrowPrev ? arrowPrev.dataset.title : '';

const swiperFs0Settings = {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 24,
    speed: 1000,
    navigation: {
        nextEl: '.speakers-slider__arrow--next',
        prevEl: '.speakers-slider__arrow--prev',
    },
    a11y: {
        nextSlideMessage: nextSlideMessage,
        prevSlideMessage: prevSlideMessage
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 3,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    }
};

const swiperFs1Settings = {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 24,
    speed: 1000,
    navigation: {
        nextEl: '.speakers-slider__arrow--next',
        prevEl: '.speakers-slider__arrow--prev',
    },
    a11y: {
        nextSlideMessage: nextSlideMessage,
        prevSlideMessage: prevSlideMessage
    },
}

const swiperFs2Settings = {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 24,
    speed: 1000,
    navigation: {
        nextEl: '.speakers-slider__arrow--next',
        prevEl: '.speakers-slider__arrow--prev',
    },
    a11y: {
        nextSlideMessage: nextSlideMessage,
        prevSlideMessage: prevSlideMessage
    },
}

export default function initializeSlider() {
    initializeSpeakersSlider();
    removeSliderDuplicatesFocus();
}

function initializeSpeakersSlider() {
    let body = document.querySelector('body');
    let speakersSlider = document.querySelector('.speakers-slider');

    if (!speakersSlider) {
        return;
    }

    if (body.classList.contains('body--fs-2')) {
        swiper = new Swiper('.speakers-slider', swiperFs2Settings);
    } else if (body.classList.contains('body--fs-1')) {
        swiper = new Swiper('.speakers-slider', swiperFs1Settings);
    } else {
        swiper = new Swiper('.speakers-slider', swiperFs0Settings);
    }

    new ClassWatcher(body, 'body--fs-0', onClassAddFs0, onClassRemoval);
    new ClassWatcher(body, 'body--fs-1', onClassAddFs1, onClassRemoval);
    new ClassWatcher(body, 'body--fs-2', onClassAddFs2, onClassRemoval);
}

function onClassAddFs0() {
    onClassAdd(swiperFs0Settings);
}

function onClassAddFs1() {
    onClassAdd(swiperFs1Settings);
}

function onClassAddFs2() {
    onClassAdd(swiperFs2Settings);
}

function onClassAdd(settings) {
    swiper.destroy();
    swiper = new Swiper('.speakers-slider', settings);

    removeSliderDuplicatesFocus();
}

function onClassRemoval() {
}

function removeSliderDuplicatesFocus() {
    document.querySelectorAll('.swiper-slide-duplicate .speakers-slide__link').forEach(item => {
        item.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
    });
}